export default "__VITE_ASSET__BaFzc$bP__"